<div style="padding: 30px">
  <div class="close-icon" mat-button (click)="dialogRef.close()"></div>
  <div *ngIf="form" [formGroup]="form">
    <div class="control-item-component">
      <h2
        style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Send Message to Control Owner</h2>
      <div [formGroup]="form">
        <div style="display: flex; flex-direction: row;">
          <div style="flex:1 1 20%">
            <mat-form-field class="example-full-width">
              <mat-label>Message</mat-label>
              <input matInput formControlName="text">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <button mat-raised-button (click)="onSave()" style="border-radius: 6px;">Send</button>
    <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
  </div>
</div>
